import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { QuestionOption } from "./question-option.entity";
import { QuestionPage } from "./question-page.entity";

export enum QuestionType {
  SELECT_SCORE = 'selectScore',
  FREE_TEXT = 'freeText',
  DROPDOWN = 'dropdown',
  RADIO_BUTTON = 'radioButton',
  CHECKBOX = 'checkBox',
  ZIPCODE = 'zipcode',
  CALENDAR = 'calendar',
}

export type SCORE_VAL = 1|2|3|4|5|6|7|8|9|10;

@Entity()
export class Question extends CommonColumns {

  @ManyToOne(() => QuestionPage, questionPage => questionPage.questions, { nullable: false, })
  @JoinColumn({ name: 'question_page_id', referencedColumnName: 'id', })
  questionPage: QuestionPage;

  @Column({ default: true, })
  enable_question: boolean;

  @Column({ default: true, })
  required: boolean;

  @Column({
    name: 'question_type',
    enum: QuestionType,
  })
  questionType: QuestionType;

  @Column({ name: 'question_type_attr', })
  questionTypeAttr: 'string';

  // 便宜上、SELECT_SCORE以外の質問タイプの時も設定する
  @Column({ name: 'max_score', default: 5, })
  maxScore: number;

  @Column({ name: 'question_text', })
  questionText: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @OneToMany(() => QuestionOption, questionOption => questionOption.question)
  questionOptions: QuestionOption[];

  constructor(props: TQuestion) {
    super();
    Object.assign(this, props);
  }
}

export declare type TQuestion = Omit<Question, 'dummy-no-such-field'>;
export interface IQuestion extends TQuestion {};
